import MsTrackingBox from './src/TrackingBox.vue'

export default MsTrackingBox
